import { render } from "./Purchase.vue?vue&type=template&id=1b019b54&scoped=true"
import script from "./Purchase.vue?vue&type=script&lang=js"
export * from "./Purchase.vue?vue&type=script&lang=js"

import "./Purchase.vue?vue&type=style&index=0&id=1b019b54&scoped=true&lang=scss"

import exportComponent from "/Users/adamklemm/vues/pmp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b019b54"]])

export default __exports__